module.exports = __webpack_public_path__ + "img/banner_4.dcd0a354.jpg";